export default {
  // Page title and navigation
  'pages.net-fee.title': 'Network Fee',
  'pages.net-fee.subtitle': 'Manage community network bill generation, payment and inquiry',
  'pages.net-fee.currentSelection': 'Current selection:',
  'pages.net-fee.batchGenerate': 'Batch Generate',
  'pages.net-fee.treeTitle': 'Building Floor House Selection',
  'pages.net-fee.tabOther': 'Other',

  // Breadcrumb navigation
  'pages.breadcrumb.chargeManagement': 'Charge Management',
  'pages.breadcrumb.netFee': 'Network Fee',

  // Batch generate related
  'pages.net-fee.batchGenerate.modalTitle': 'Batch Generate Network Fee Bills',
  'pages.net-fee.batchGenerate.confirmTitle': 'Confirm Batch Generate',
  'pages.net-fee.batchGenerate.confirmMessage': 'Are you sure you want to batch generate network fee bills for {period}?',
  'pages.net-fee.batchGenerate.selectPeriod': 'Select Period:',
  'pages.net-fee.batchGenerate.selectPeriodPlaceholder': 'Please select period',
  'pages.net-fee.batchGenerate.confirmGenerate': 'Confirm Generate',
  'pages.net-fee.batchGenerate.cancel': 'Cancel',
  'pages.net-fee.batchGenerate.tips': '💡 Tips: Batch generation will create network fee bills for all houses without generated bills for the specified period',
  'pages.net-fee.batchGenerate.tips2': 'Existing bills will not be generated again',
  'pages.net-fee.batchGenerate.success': 'Successfully generated {count} bills',
  'pages.net-fee.batchGenerate.failure': 'Batch generate failed',
  'pages.net-fee.batchGenerate.selectPeriodFirst': 'Please select period first',

  // Table related
  'pages.net-fee.table.title': 'Network Fee Bill List',
  'pages.net-fee.table.houseInfo': 'House Info',
  'pages.net-fee.table.period': 'Period',
  'pages.net-fee.table.billNo': 'Bill No.',
  'pages.net-fee.table.finalAmount': 'Final Amount',
  'pages.net-fee.table.approvalStatus': 'Approval Status',
  'pages.net-fee.table.paymentStatus': 'Payment Status',
  'pages.net-fee.table.paymentTime': 'Payment Time',
  'pages.net-fee.table.dueDate': 'Due Date',
  'pages.net-fee.table.action': 'Action',

  // Action buttons
  'pages.net-fee.action.view': 'View',
  'pages.net-fee.action.edit': 'Edit',
  'pages.net-fee.action.delete': 'Delete',
  'pages.net-fee.action.create': 'Create Bill',
  'pages.net-fee.action.submitAudit': 'Submit Audit',
  'pages.net-fee.action.batchDelete': 'Batch Delete',
  'pages.net-fee.action.confirm': 'Confirm',
  'pages.net-fee.action.cancel': 'Cancel',

  // Delete related
  'pages.net-fee.delete.confirmTitle': 'Are you sure you want to delete this record?',
  'pages.net-fee.delete.success': 'Deleted successfully',
  'pages.net-fee.delete.failure': 'Delete failed',
  'pages.net-fee.delete.batchDelete.confirmTitle': 'Confirm Delete',
  'pages.net-fee.delete.batchDelete.confirmMessage': 'Are you sure you want to delete the selected {count} records?',
  'pages.net-fee.delete.batchDelete.success': 'Batch delete successful',
  'pages.net-fee.delete.batchDelete.failure': 'Batch delete failed',
  'pages.net-fee.delete.selectRecordsWarning': 'Please select records to delete',

  // Audit related
  'pages.net-fee.audit.selectBillsWarning': 'Please select bills to submit for audit',
  'pages.net-fee.audit.modalTitle': 'Submit Audit',
  'pages.net-fee.audit.submitAudit': 'Submit Audit',
  'pages.net-fee.audit.auditName': 'Audit Name',
  'pages.net-fee.audit.auditNamePlaceholder': 'Please enter audit name',
  'pages.net-fee.audit.auditNameRequired': 'Please enter audit name',
  'pages.net-fee.audit.submitRemark': 'Submit Remarks',
  'pages.net-fee.audit.submitRemarkPlaceholder': 'Please enter submit remarks (optional)',
  'pages.net-fee.audit.selectedBillsTitle': 'Selected Bills List (Total {count})',
  'pages.net-fee.audit.success': 'Audit submitted successfully',
  'pages.net-fee.audit.failure': 'Audit submission failed',
  'pages.net-fee.audit.defaultName': '{period} Network Fee Bills ({count})',
  'pages.net-fee.audit.fetchAuditRecordError': 'Failed to fetch audit records',

  // Detail modal
  'pages.net-fee.detail.modalTitle': 'Network Fee Bill Details',
  'pages.net-fee.detail.close': 'Close',
  'pages.net-fee.detail.basicInfo': 'Basic Information',
  'pages.net-fee.detail.houseOwnerInfo': 'House & Owner Information',
  'pages.net-fee.detail.amountInfo': 'Amount Information',
  'pages.net-fee.detail.paymentInfo': 'Payment Information',
  'pages.net-fee.detail.systemInfo': 'System Information',
  'pages.net-fee.detail.auditRecord': 'Audit Records',
  'pages.net-fee.detail.loading': 'Loading...',
  'pages.net-fee.detail.noAuditRecord': 'No audit records',

  // Detail fields
  'pages.net-fee.detail.billNo': 'Bill No.',
  'pages.net-fee.detail.period': 'Period',
  'pages.net-fee.detail.paymentStatus': 'Payment Status',
  'pages.net-fee.detail.approvalStatus': 'Approval Status',
  'pages.net-fee.detail.startDate': 'Start Date',
  'pages.net-fee.detail.endDate': 'End Date',
  'pages.net-fee.detail.houseInfo': 'House Information',
  'pages.net-fee.detail.ownerInfo': 'Owner Information',
  'pages.net-fee.detail.ownerIdCard': 'ID Card',
  'pages.net-fee.detail.ownerEmail': 'Email',
  'pages.net-fee.detail.ownerId': 'Owner ID',
  'pages.net-fee.detail.netFeeAmount': 'Network Fee Amount',
  'pages.net-fee.detail.lateFee': 'Late Fee',
  'pages.net-fee.detail.discountAmount': 'Discount Amount',
  'pages.net-fee.detail.finalAmount': 'Final Amount',
  'pages.net-fee.detail.paymentMethod': 'Payment Method',
  'pages.net-fee.detail.paymentReference': 'Payment Reference',
  'pages.net-fee.detail.dueDate': 'Due Date',
  'pages.net-fee.detail.paymentDate': 'Payment Date',
  'pages.net-fee.detail.createdTime': 'Created Time',
  'pages.net-fee.detail.updatedTime': 'Updated Time',
  'pages.net-fee.detail.remarks': 'Remarks',

  // Status related
  'pages.net-fee.status.unpaid': 'Unpaid',
  'pages.net-fee.status.paid': 'Paid',
  'pages.net-fee.status.overdue': 'Overdue',
  'pages.net-fee.status.partial': 'Partial',
  'pages.net-fee.status.cancelled': 'Cancelled',

  // Approval status
  'pages.net-fee.approvalStatus.draft': 'Draft',
  'pages.net-fee.approvalStatus.pending': 'Pending',
  'pages.net-fee.approvalStatus.approved': 'Approved',
  'pages.net-fee.approvalStatus.rejected': 'Rejected',
  'pages.net-fee.approvalStatus.notified': 'Notified',
  'pages.net-fee.approvalStatus.overdue': 'Overdue',
  'pages.net-fee.approvalStatus.cancelled': 'Cancelled',

  // Form related
  'pages.net-fee.form.editTitle': 'Edit Network Fee Bill',
  'pages.net-fee.form.createTitle': 'Create Network Fee Bill',
  'pages.net-fee.form.basicInfo': 'Basic Information',
  'pages.net-fee.form.houseOwnerInfo': 'House & Owner Information',
  'pages.net-fee.form.feeInfo': 'Fee Information',
  'pages.net-fee.form.remarksInfo': 'Remarks',
  'pages.net-fee.form.update': 'Update',
  'pages.net-fee.form.create': 'Create',
  'pages.net-fee.form.cancel': 'Cancel',

  // Form fields
  'pages.net-fee.form.billNo': 'Bill No.',
  'pages.net-fee.form.billNoPlaceholder': 'Please enter bill number',
  'pages.net-fee.form.paymentStatus': 'Payment Status',
  'pages.net-fee.form.paymentStatusPlaceholder': 'Please select payment status',
  'pages.net-fee.form.period': 'Period',
  'pages.net-fee.form.periodPlaceholder': 'e.g.: 2024-01',
  'pages.net-fee.form.periodRequired': 'Please enter period',
  'pages.net-fee.form.startDate': 'Start Date',
  'pages.net-fee.form.startDatePlaceholder': 'Please select start date',
  'pages.net-fee.form.startDateRequired': 'Please select start date',
  'pages.net-fee.form.endDate': 'End Date',
  'pages.net-fee.form.endDatePlaceholder': 'Please select end date',
  'pages.net-fee.form.endDateRequired': 'Please select end date',
  'pages.net-fee.form.building': 'Building',
  'pages.net-fee.form.buildingPlaceholder': 'Please select building',
  'pages.net-fee.form.buildingRequired': 'Please select building',
  'pages.net-fee.form.floor': 'Floor',
  'pages.net-fee.form.floorPlaceholder': 'Please select floor',
  'pages.net-fee.form.floorRequired': 'Please select floor',
  'pages.net-fee.form.house': 'House',
  'pages.net-fee.form.housePlaceholder': 'Please select house',
  'pages.net-fee.form.houseRequired': 'Please select house',
  'pages.net-fee.form.netFeeAmount': 'Network Fee Amount',
  'pages.net-fee.form.netFeeAmountPlaceholder': 'Please enter network fee amount',
  'pages.net-fee.form.netFeeAmountRequired': 'Please enter network fee amount',
  'pages.net-fee.form.lateFee': 'Late Fee',
  'pages.net-fee.form.lateFeePlaceholder': 'Please enter late fee',
  'pages.net-fee.form.discountAmount': 'Discount Amount',
  'pages.net-fee.form.discountAmountPlaceholder': 'Please enter discount amount',
  'pages.net-fee.form.finalAmount': 'Final Amount',
  'pages.net-fee.form.finalAmountPlaceholder': 'Auto Calculate',
  'pages.net-fee.form.finalAmountRequired': 'Final amount will be calculated automatically',
  'pages.net-fee.form.remarks': 'Remarks',
  'pages.net-fee.form.remarksPlaceholder': 'Please enter remarks',
  'pages.net-fee.form.remarksMaxLength': 'Remarks length cannot exceed 500 characters',

  // Form validation and error messages
  'pages.net-fee.form.serviceNotAvailable': 'This house does not have network service enabled, please select another house',
  'pages.net-fee.form.loadPriceConfigError': 'Failed to load network fee price configuration',
  'pages.net-fee.form.submitSuccess': 'Created successfully',
  'pages.net-fee.form.updateSuccess': 'Updated successfully',
  'pages.net-fee.form.submitError': 'Submission failed',

  // Currency unit
  'pages.net-fee.currency.yuan': '₱',
  'pages.net-fee.currency.php': '₱',

  // Detail Component Fields
  'pages.net-fee.detail.basicInfo': 'Basic Information',
  'pages.net-fee.detail.billNo': 'Bill Number',
  'pages.net-fee.detail.period': 'Period',
  'pages.net-fee.detail.paymentStatus': 'Payment Status',
  'pages.net-fee.detail.approvalStatus': 'Approval Status',
  'pages.net-fee.detail.startDate': 'Start Date',
  'pages.net-fee.detail.endDate': 'End Date',
  'pages.net-fee.detail.houseOwnerInfo': 'House & Owner Information',
  'pages.net-fee.detail.houseInfo': 'House Information',
  'pages.net-fee.detail.ownerInfo': 'Owner Information',
  'pages.net-fee.detail.amountInfo': 'Amount Information',
  'pages.net-fee.detail.baseAmount': 'Base Amount',
  'pages.net-fee.detail.lateFee': 'Late Fee',
  'pages.net-fee.detail.discountAmount': 'Discount Amount',
  'pages.net-fee.detail.finalAmount': 'Final Amount',
  'pages.net-fee.detail.paymentInfo': 'Payment Information',
  'pages.net-fee.detail.paymentMethod': 'Payment Method',
  'pages.net-fee.detail.paymentReference': 'Payment Reference',
  'pages.net-fee.detail.dueDate': 'Due Date',
  'pages.net-fee.detail.paymentDate': 'Payment Date',
  'pages.net-fee.detail.systemInfo': 'System Information',
  'pages.net-fee.detail.createdTime': 'Created Time',
  'pages.net-fee.detail.updatedTime': 'Updated Time',
  'pages.net-fee.detail.remarks': 'Remarks',

  // Pagination
  'pages.net-fee.table.pagination.showTotal': 'Items {start}-{end} of {total}',
};
